<template>
  <v-subheader class="grey lighten-2">
    <v-row dense class="text--primary body-1 font-weight-medium">
      <v-col cols="12" :sm="disableActions ? 4 : 3">
        {{ carrinho.respostaCotacao.cotacao.identificador }}
      </v-col>
      <v-col cols="12" sm="2" class="d-flex align-center">
        <px-finalidade-compra-value
          :finalidade-compra="carrinho.respostaCotacao.cotacao.finalidadeCompra"/>
      </v-col>
      <v-col cols="12" sm="2" class="d-flex align-center">
        <px-forma-pagamento
          :forma-pagamento="carrinho.respostaCotacao.formaPagamento"
          :prazo-pagamento="carrinho.respostaCotacao.prazoPagamento"/>
      </v-col>
      <v-col cols="12" sm="2" class="d-flex align-center">
            <span v-if="carrinho.frete">
              {{ carrinho.respostaCotacao.frete.tipoFrete }}
              ({{ carrinho.frete | currency }})
            </span>
        <span v-else>
              {{ carrinho.respostaCotacao.frete.tipoFrete }}
            </span>
      </v-col>
      <v-col cols="12" sm="2" class="d-flex align-center">
        Total: {{ carrinho.total |
        currency(simboloMoeda, casaDecimal(carrinho), configuracaoFormatacaoMoeda) }}
        <px-moeda-chip v-if="isMoedaEstrangeira" class="ml-2" :moeda="moeda"/>
      </v-col>
      <v-col cols="12" sm="1" v-if="!disableActions && hasModuleGerencia"
             class="d-flex align-center justify-end">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
                        <span v-on="on">
                         <v-btn icon small @click.stop="removerCarrinho(carrinho.id)"
                                title="Remover todos os produtos do carrinho">
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>
                        </span>
          </template>
          <span>Remover todos os produtos do carrinho</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </v-subheader>
</template>
<script>
import { mapGetters } from 'vuex';
import { CasaDecimalUtils } from 'px-components';
import moedaMixin from '@/mixins/moeda-mixin';

export default {
  mixins: [moedaMixin],
  name: 'ListagemCarrinhoRespostas',
  props: {
    carrinho: {
      type: Object,
      required: true,
    },
    disableActions: {
      type: Boolean,
      default: false,
    },
    removerCarrinho: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters('user', ['hasModuleGerencia']),
    moeda() {
      return this.carrinho.respostaCotacao.moeda;
    },
    casaDecimal() {
      return (carrinho) => {
        const produtos = carrinho.produtos.map(
          produto => produto.respostaCotacaoProduto.cotacaoProduto.produto,
        );
        return CasaDecimalUtils.getCasaDecimal(produtos);
      };
    },
  },
};
</script>
